import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import storage from './storage';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export default function useLocalStorageStateBase(key, defaultValue) {
  // we don't support updating the `defaultValue` the same way `useState()` doesn't support it
  var _useState = useState(function () {
    var isCallable = function isCallable(value) {
      return typeof value === 'function';
    };

    return isCallable(defaultValue) ? defaultValue() : defaultValue;
  }),
      _useState2 = _slicedToArray(_useState, 1),
      defaultValueState = _useState2[0];

  var getDefaultState = useCallback(function () {
    return {
      value: storage.get(key, defaultValueState),
      isPersistent: function () {
        /**
         * We want to return `true` on the server. If you render a message based on `isPersistent` and the
         * server returns `false` then the message will flicker until hydration is done:
         * `{!isPersistent && <span>You changes aren't being persisted.</span>}`
         */
        if (typeof window === 'undefined') {
          return true;
        }

        try {
          localStorage.setItem('__ulss', '#');
          localStorage.removeItem('__ulss');
          return true;
        } catch (_a) {
          return false;
        }
      }()
    };
  }, [defaultValueState, key]);

  var _useState3 = useState(getDefaultState),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  var updateValue = useMemo(function () {
    var fn = function fn(newValue) {
      var isCallable = function isCallable(value) {
        return typeof value === 'function';
      };

      if (isCallable(newValue)) {
        setState(function (state) {
          return {
            value: newValue(state.value),
            isPersistent: storage.set(key, newValue(state.value))
          };
        });
      } else {
        setState({
          value: newValue,
          isPersistent: storage.set(key, newValue)
        });
      }
    };

    fn.reset = function () {
      storage.remove(key);
      setState(function (state) {
        return {
          value: defaultValueState,
          isPersistent: state.isPersistent
        };
      });
    };

    return fn;
  }, [key, defaultValueState]);
  /**
   * Syncs changes across tabs and iframe's.
   */

  useEffect(function () {
    var onStorage = function onStorage(e) {
      if (e.storageArea === localStorage && e.key === key) {
        setState({
          value: storage.get(key, defaultValueState),
          isPersistent: true
        });
      }
    };

    window.addEventListener('storage', onStorage);
    return function () {
      return window.removeEventListener('storage', onStorage);
    };
  }, [key, defaultValueState]);
  /**
   * Update the state when the `key` property changes.
   */

  var isFirstRender = useRef(true);
  useEffect(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setState(getDefaultState());
  }, [getDefaultState]);
  return [state.value, updateValue, state.isPersistent];
}